import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import i18next from 'i18next'

export const LOCAL_STORAGE_LOCALE = 'locale'

// Because i18next does not keep the locales in its own state, we also export
// this function to get the locales in the Language selector
export const locales = () => {
  const host = window.location.hostname
  const domainExtension = host.slice(host.lastIndexOf('.') + 1)

  switch (domainExtension) {
    default:
      return ['nl-NL', 'en-NL', 'cs-CZ']
  }
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'detectPrimary',
  lookup() {
    return locales()[0]
  },
})

export const i18n = i18next
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/i18n/{{lng}}.json`,
    },

    saveMissing: false,

    debug: false,

    supportedLngs: locales(),
    returnNull: false,

    detection: {
      order: ['localStorage', 'navigator', 'detectPrimary'],
      lookupLocalStorage: LOCAL_STORAGE_LOCALE,
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
